import { EventDetailsTabView } from '@mark43/cad-api';
import { VStack, Box } from '@cad-arc';
import { TimestampsSectionContent } from '../../event-panel/tabs/event-details/components/sections/timestamps-section-content';
import { SectionTitle } from '../../fr-event-common-components/section-title';

export function FrTimestampsSection(
    props: Partial<EventDetailsTabView & { isScheduled: boolean }>
): React.ReactElement {
    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Timestamps" />
            <Box w="100%">
                <TimestampsSectionContent {...props} />
            </Box>
        </VStack>
    );
}
